"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import t from "../components/Icon/SvgIcon.js";
const m = (c) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...c,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        d: "M21.99 6.397c0-.31-.13-.51-.39-.62l-4.947-1.98c-1.44-.58-2.879-1.15-4.318-1.73a.9.9 0 0 0-.68 0c-.65.27-1.31.53-1.969.79L2.46 5.748c-.35.14-.46.3-.46.68v10.79c0 .37.11.53.45.67l4.138 1.65c1.709.69 3.418 1.37 5.137 2.05.08.03.18.05.27.05s.18-.02.26-.05c1.07-.42 2.139-.85 3.208-1.28l6.057-2.42c.36-.15.48-.31.48-.7V6.398zm-13.173 5.55c-.1.07-.21.1-.33.1-.08 0-.16-.01-.24-.04-.26-.1-.52-.21-.79-.31l-1.809-.72c-.06-.03-.12-.05-.17-.07a.595.595 0 0 1-.29-.77.58.58 0 0 1 .74-.33c.25.09.49.19.73.28l1.979.79c.29.11.43.3.43.58 0 .2-.09.39-.25.5zm.81-3.67-2.49-1 7.317-2.9 2.459.99-7.277 2.92-.01-.01Z"
      }
    )
  }
), n = l(m);
export {
  n as BoxFilled,
  n as default
};
